<nav class="adm-tabbar" aria-label="Primary (mobile)">
  @for (tab of tabs(); track tab.path) {
    <a
      class="adm-tabbar__tab"
      [class.adm-tabbar__tab--active]="isActive(tab)"
      [routerLink]="tab.path"
      routerLinkActive="adm-tabbar__tab--active"
      [attr.aria-current]="isActive(tab) ? 'page' : null">
      <span class="adm-tabbar__indicator" aria-hidden="true"></span>
      <i class="bx {{ tab.icon }} adm-tabbar__icon" aria-hidden="true"></i>
      <span class="adm-tabbar__label">{{ tab.label }}</span>
    </a>
  }
</nav>
